import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Select, Button, Collapse} from 'antd'
import groovyManagementAPI from '../../../apis/groovyManagement'
import {Base64} from 'js-base64'
import Editor from '../../../utils/brace'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'

const {Panel} = Collapse

class FormModal extends Component {
  formRef = React.createRef()
  editorRef1 = React.createRef()
  state = {
    script: null
  }

  handleOk = () => {
    const {handleCancel, handleSearch} = this.props

    if (!this.state.script) {
      alertMessage.error('Please enter Script')
      return
    }
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        client: fieldsValue.client,
        script: Base64.encode(this.state.script)
      }
      groovyManagementAPI.addAction(params).then(res => {
        handleCancel('addModalVisible')
        handleSearch()
      })
    }).catch(err => { })
  }

  editorChange = (data) => {
    this.setState({
      script: data
    }, () => {
    })
  }

  render() {
    const {addModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`groovyManagement.groovy`)}`}
          width="70%"
          closable={true}
          onCancel={() => handleCancel('addModalVisible')}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('addModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col span={6}>
                <Form.Item name="name" label={t(`groovyManagement.name`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`groovyManagement.name`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="client" label={t(`groovyManagement.module`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`groovyManagement.module`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key="DataSource" value="DATASOURCE">DataSource</Select.Option>
                    <Select.Option key="DataTarget" value="DATATARGET">DataTarget</Select.Option>
                    <Select.Option key="InBoundAPI" value="INBOUNDAPI">InBound API</Select.Option>
                    <Select.Option key="OutBoundAPI" value="OUTBOUNDAPI">OutBound API</Select.Option>
                    <Select.Option key="Mapping" value="MAPPING">Mapping</Select.Option>
                    <Select.Option key="Mappingpre" value="MAPPINGPRE">Mapping pre</Select.Option>
                    <Select.Option key="Mappingpost" value="MAPPINGPOST">Mapping post</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Collapse defaultActiveKey={['1', '2', '3']}>
                  <Panel header={t(`groovyManagement.script`)} key="1">
                    {
                      <Editor
                        ref={this.editorRef1}
                        mode="json"
                        width="100%"
                        height="300px"
                        theme="chrome"
                        enableBasicAutocompletion={false}
                        enableLiveAutocompletion={false}
                        enableSnippets={false}
                        enableEmmet={false}
                        useElasticTabstops={false}
                        setOptions={{useWorker: false}}
                        fontSize="16px"
                        value={this.state.script ? this.state.script : null}
                        readonly={false}
                        onChange={this.editorChange}
                      ></Editor>
                    }
                  </Panel>
                </Collapse>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
